import { Component, OnInit, OnDestroy, OnChanges, Input, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';

@Component({
  selector: 'app-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss'],
})
export class SelectFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() labelName: string;
  @Input() placeholder: string;
  @Input() items: Array<any>;
  @Input() isRefreshing: boolean;
  @Input() seleteditem: any;
  @Input() key = 'name';
  @Input() suspendticket: boolean;
  @Input() error = {erc: '1', value: ''};
  @Input() emptyMessage: string;
  @Input() searchingItems: boolean;
  @Output() filterData: EventEmitter<any> = new EventEmitter();
  @Output() loadMore = new EventEmitter();
  @Output() itemChanged = new EventEmitter();
  @Output() refresh = new EventEmitter();
  searchdata = {
    filter: '',
    perpage: 50,
    page: 0
  };
  item = [];
  select: boolean;
  constructor(private sportService: SportServicesService, private translate: TranslateService) {
    this.sportService.subjectItem.subscribe(data => {
      if (data !== '') {
        this.searchdata = {...this.searchdata, filter: data};
      }
      focus();
    });
  }

  ngOnInit() {
    if(this.seleteditem){
      this.searchdata = {...this.searchdata, filter: this.seleteditem[this.key]};
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['seleteditem']){
      const selectedItem = changes['seleteditem'].currentValue;
      this.searchdata = {...this.searchdata, filter: selectedItem ?  selectedItem[this.key] : ''};
    }
    
    if(changes['isRefreshing']){
      const isRefreshing = changes['isRefreshing'].currentValue;
      
      if(isRefreshing){
        this.searchdata = {...this.searchdata, filter:''};
      }
    }
    
  }

  filterEvents() {
    if (this.searchdata.filter.trim().length < 3 && this.searchdata.filter.length > 0) {
      return;
    } else {
      this.filterData.emit(this.searchdata);
    }
  }
  refreshing(){
    this.refresh.emit();
    setTimeout(() => {
      if(this.items.length == 0){
        this.select = false;
      }
    }, 500);

  }
  loadMoreEvents() {
    this.searchdata.page++;
    this.loadMore.emit(this.searchdata);

  }
  closeDropdown() {
    setTimeout(() => {
      if (!this.isRefreshing) {
        this.select = false;
      }
    }, 300);
  }
  openDropDown() {
    this.select = true;
  }
  setEvent(item) {
    this.seleteditem = item;
    if (item.hasOwnProperty('id') && item.id.toString().includes('sr:tournament')) {
      this.searchdata.filter = item['category']['name'] + '-' + item[this.key] ;
    }
    else if (item.hasOwnProperty('id') && item.id.toString().includes('sr:category') && this.suspendticket) {
      this.searchdata.filter = item['sport']['name'] + '-' + item[this.key] ;
    } else {
      this.searchdata.filter = this.labelName.toLocaleLowerCase().includes('sta') && item[this.key] !== '' ? this.translate.instant(item[this.key]) : item[this.key];
    }
    this.itemChanged.emit(this.seleteditem);
    // this.sportService.setSelectedSportId(item['id']);
    this.select = false;
  }
  ngOnDestroy() {
    this.sportService.subjectItem.next('');
  }
}
